<template>
    <CompassModal
        v-model:visible="showModal"
        :size="CompassEnums.ModalSize.SMALL"
        :title="$t.__('email.ScheduledEmailListing.batchDeleteConfirmModal.title')"
        :closeOnClickOverlay="false"
        class="scheduled-emails-batch-delete-confirm-dialog"
        :primaryAction="{
            label: $t.__('common.actions.delete'),
            loading: isLoading,
            type: CompassEnums.ButtonType.PRIMARY_DESTRUCTIVE,
            action: () => handleConfirm(),
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                disabled: isLoading,
                action: () => closeModal(),
            },
        ]"
        @closed="closeModal"
    >
        <p
            class="typographies-paragraph-medium-regular scheduled-emails-batch-delete-confirm-dialog__description"
        >
            {{
                $t.n__(
                    'email.ScheduledEmailListing.batchDeleteConfirmModal.description',
                    null,
                    emailsCount,
                    emailsCount,
                )
            }}
        </p>
    </CompassModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface Props {
    emailsCount: number;
    isLoading?: boolean;
}

withDefaults(defineProps<Props>(), {
    isLoading: false,
});

const emit = defineEmits<{
    (event: 'confirm'): void;
    (event: 'close'): void;
}>();

const showModal = ref<boolean>(true);

const handleConfirm = (): void => {
    emit('confirm');
};

const closeModal = (): void => {
    showModal.value = false;
    emit('close');
};
</script>

<style lang="scss" scoped>
.scheduled-emails-batch-delete-confirm-dialog {
    &__description {
        margin: 0;
    }
}
</style>
